/**
 * PRINT SERVICE (FINAL PREMIUM VERSION)
 */

export const generatePrintTemplate = (memoData) => {
  const rows = memoData.items
    .map(
      (it, i) => `
      <tr>
        <td>${i + 1}</td>
        <td>${it.productName}</td>
        <td>${it.designNumber}</td>
        <td>${it.qty}</td>
        <td>₹${Number(it.wRate).toLocaleString("en-IN")}</td>
        <td>₹${Number(it.total).toLocaleString("en-IN")}</td>
      </tr>
    `
    )
    .join("");

  return `
  <!DOCTYPE html>
  <html>
  <head>
    <meta charset="UTF-8" />
    <title>Invoice</title>

    <style>
      @page { size: A4; margin: 18mm; }

      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }

      body {
        font-family: "Segoe UI", Arial, sans-serif;
        color: #111;
        background: #fff;
      }

      .invoice {
        max-width: 900px;
        margin: auto;
      }

      /* HEADER */
      .header {
        text-align: center;
        margin-bottom: 30px;
      }

      .logo img {
        height: 55px;
      }

      .title {
        font-size: 24px;
        font-weight: 700;
        letter-spacing: 1px;
      }

      .sub {
        font-size: 12px;
        color: #777;
        margin-top: 4px;
      }

      /* TOP BOX */
      .topBox {
        display: flex;
        justify-content: space-between;
        margin-bottom: 25px;
        padding-bottom: 10px;
        border-bottom: 1px solid #e5e7eb;
      }

      .leftInfo {
        font-size: 14px;
        line-height: 1.8;
      }

      .rightInfo {
        text-align: right;
        font-size: 13px;
      }

      .invoiceTag {
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 1px;
        margin-bottom: 6px;
      }

      /* TABLE */
      table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 10px;
      }

      thead {
        border-bottom: 2px solid #111;
      }

      th {
        padding: 10px;
        font-size: 12px;
        text-align: left;
        font-weight: 700;
      }

      td {
        padding: 10px;
        font-size: 13px;
        border-bottom: 1px solid #eee;
        text-align: left;
      }

      td:last-child, th:last-child {
        text-align: right;
      }

      /* TOTAL */
      .total {
        margin-top: 25px;
        display: flex;
        justify-content: flex-end;
      }

      .totalBox {
        text-align: right;
      }

      .totalLabel {
        font-size: 13px;
        color: #555;
      }

      .totalValue {
        font-size: 18px;
        font-weight: 700;
      }

      /* FOOTER */
      .footer {
        margin-top: 50px;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
      }

      .note {
        max-width: 320px;
      }

      .noteTitle {
        font-size: 12px;
        font-weight: 700;
        margin-bottom: 5px;
      }

      .note p {
        font-size: 12px;
        color: #555;
        line-height: 1.6;
      }

      .signLine {
        margin-top: 60px;
        border-top: 1px solid #111;
        width: 180px;
        text-align: center;
        padding-top: 5px;
        font-size: 12px;
      }

      /* WATERMARK */
      .watermark {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        opacity: 0.04;
      }

      .watermark img {
        width: 280px;
      }

      .page {
  min-height: 100vh;           /* full page height */
  display: flex;
  flex-direction: column;
}

.content {
  flex: 1;                     /* content stretch karega */
}

.footer {
  display: flex;
  justify-content: flex-end;   /* right side */
  padding: 20px;
}

.signLine {
  border-top: 1px solid #000;
  width: 200px;
  text-align: center;
  padding-top: 5px;
}

    </style>
  </head>

  <body>

    <div class="watermark">
      <img src="/mtlogo.jpg" />
    </div>

    <div class="invoice">

      <div class="header">
        <div class="logo">
          <img src="/mtlogo.jpg" />
        </div>
        <div class="title">APPROVAL MEMO</div>
        <div class="sub">Provisional Invoice</div>
      </div>

      <!-- TOP INFO -->
      <div class="topBox">
        <div class="leftInfo">
          <div><b>Name:</b> ${memoData.customerName || "-"}</div>
          <div><b>Mobile:</b> ${memoData.mobile || "-"}</div>
        </div>

        <div class="rightInfo">
          <div class="invoiceTag">INVOICE</div>
          <div><b>Date:</b> ${memoData.invoiceDate || "-"}</div>
        </div>
      </div>

      <!-- TABLE -->
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>Product</th>
            <th>Design</th>
            <th>Qty</th>
            <th>Rate</th>
            <th>Total</th>
          </tr>
        </thead>

        <tbody>
          ${rows}
        </tbody>
      </table>

      <!-- TOTAL -->
      <div class="total">
        <div class="totalBox">
          <div class="totalLabel">Grand Total</div>
          <div class="totalValue">
            ₹${Number(memoData.grandTotal || 0).toLocaleString("en-IN")}
          </div>
        </div>
      </div>

      <!-- FOOTER -->
      <div class="footer">
       

        <div>
          <div class="signLine">Authorized Signature</div>
        </div>
      </div>

    </div>

    <script>
      window.onload = function () {
        setTimeout(() => window.print(), 300);
      };
    </script>

  </body>
  </html>
  `;
};

/* OPEN PRINT WINDOW */
export const openPrintWindow = (memoData) => {
  try {
    const w = window.open("", "_blank", "width=900,height=700");

    if (!w) {
      alert("Popup blocked! Please allow popups.");
      return false;
    }

    const html = generatePrintTemplate(memoData);
    w.document.write(html);
    w.document.close();

    return true;
  } catch (err) {
    console.error(err);
    return false;
  }
};

/* DIRECT PRINT */
export const printOnly = (memoData) => {
  return openPrintWindow(memoData);
};